import React, { useState, useEffect } from "react";
import moment from "moment";
import { IoIosClose } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const customStyles = {
	"--react-datepicker-time-list-bg": "white",
};
const DateandTimePicker2 = ({
	date,
	isModalOpen,
	setIsModalOpen,
	setRequestSent,
	propertyEarlyCheckInTime,
	propertyTime,
	propertyTimeZone,
	addon,
}) => {
	console.log(
		"DateandTimePicker rendered with date:",
		propertyEarlyCheckInTime,
	);
	const [selectedDate, setSelectedDate] = useState(null);
	const [selectedTime, setSelectedTime] = useState("");
	const [timeSlots, setTimeSlots] = useState([]);
	const [isEarlyCheckIn, setIsEarlyCheckIn] = useState(false);

	// Convert 24hr to 12hr format
	const convert24to12 = (time24) => {
		return moment(time24, "HH:mm").format("hh:mm A");
	};

	// Check if selected time is 15 minutes or more before standard check-in time
	const checkIfEarlyCheckIn = (selectedTimeStr, standardCheckInTime) => {
		if (!selectedTimeStr || !standardCheckInTime) return false;
		
		const selected = moment(selectedTimeStr, "hh:mm A");
		const standard = moment(standardCheckInTime, "HH:mm");
		
		// If selected time is exactly the standard check-in time, it's not early check-in
		if (selected.isSame(standard)) return false;
		
		// Calculate difference in minutes
		const diffMinutes = standard.diff(selected, 'minutes');
		
		// Return true if selected time is 15 minutes or more before standard time
		return diffMinutes >= 15;
	};

	const generateTimeSlots = (start, end, intervalMinutes) => {
		const slots = [];
		let current = new Date(start);
		const endDate = new Date(end);

		while (current <= endDate) {
			// Convert directly to 12-hour format
			const time12 = moment(current).format("hh:mm A");
			slots.push(time12);
			current.setMinutes(current.getMinutes() + intervalMinutes);
		}
		console.log(slots);
		return slots;
	};

	useEffect(() => {
		const now = new Date();
		// Convert propertyTime from 24hr to 12hr format
		const propertyTime12 = convert24to12(propertyTime || "00:00");
		const [propertyHour, propertyMinute] = moment(propertyTime12, "hh:mm A")
			.format("HH:mm")
			.split(":")
			.map(Number);

		// Start time: 15 minutes before standard check-in time
		const startTime = new Date();
		startTime.setHours(propertyHour, propertyMinute - 15, 0);

		// End time: 11:45 PM
		const endTime = new Date();
		endTime.setHours(23, 45, 0); // 11:45 PM

		// Generate time slots from start time to end time with 15-minute intervals
		const slots = generateTimeSlots(startTime, endTime, 15);

		// Include the standard check-in time in the slots if it's not already there
		if (!slots.includes(propertyTime12)) {
			slots.push(propertyTime12);
		}

		// Sort the slots chronologically
		slots.sort((a, b) => {
			const timeA = moment(a, "hh:mm A");
			const timeB = moment(b, "hh:mm A");
			return timeA.diff(timeB);
		});

		setTimeSlots(slots);
		// Set standard check-in time as default selected time
		setSelectedTime(propertyTime12);

		console.log("Time Slots: ", slots);
	}, [propertyTime, propertyEarlyCheckInTime]);

	// Check if selected time is early check-in whenever selectedTime changes
	useEffect(() => {
		const isEarly = checkIfEarlyCheckIn(selectedTime, propertyTime);
		setIsEarlyCheckIn(isEarly);
	}, [selectedTime, propertyTime]);

	return (
		<div
			className={`fixed bottom-0 left-0 w-full bg-white p-4 shadow-lg transition-transform transform ${
				isModalOpen ? "translate-y-0" : "translate-y-full"
			} h-80`}
			style={{ zIndex: 9999 }}
		>
			<div className="flex items-center justify-between pb-4">
				<div className="text-lg text-black">Early check-in date and time</div>
				<button
					onClick={(e) => {
						e.preventDefault();
						setIsModalOpen(false);
					}}
				>
					<IoIosClose className="h-8 w-8 text-black" />
				</button>
			</div>

			<div className="flex items-center justify-center bg-white">
				<input
					value={`On ${moment(date).format("MM-DD-YYYY")}`}
					placeholderText="Select Date"
					className="w-full px-10 py-3 border border-gray-400 rounded-md text-lg text-black"
					popperClassName="custom-datepicker"
					style={customStyles}
					disabled={true}
				/>
			</div>

			<div className="mb-4 text-lg text-center">
				<div className="text-left text-black">
					Select Time: {propertyTimeZone}
				</div>
				{timeSlots.length > 0 ? (
					<select
						value={selectedTime}
						onChange={(e) => setSelectedTime(e.target.value)}
						className="w-full mt-2 px-4 py-2 border border-gray-400 rounded-md text-black"
					>
						<option value="" disabled className="text-black">
							Select Time {propertyTimeZone}
						</option>
						{timeSlots.map((slot, index) => (
							<option key={index} value={slot} className="text-black">
								{slot}
							</option>
						))}
					</select>
				) : (
					<div className="text-black">No available time slots</div>
				)}
			</div>

			<button
				className="w-full py-2 mt-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50"
				onClick={(e) => {
					e.preventDefault();
					setRequestSent(selectedTime); // Sending 12hr format to parent
					setIsModalOpen(false);
				}}
			>
				Send Request {isEarlyCheckIn && addon && addon.price ? `($${addon?.price})` : ""}
			</button>
		</div>
	);
};

export default DateandTimePicker2;
